module.exports = "/packs/images/products/devices/flat-devicekit-be942fd6f545e6ee598b935e2a34900d.png";


//////////////////
// WEBPACK FOOTER
// ./app/javascript/images/products/devices/flat-devicekit.png
// module id = 1796
// module chunks = 0